import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  assignmentSelector,
  homeworkSelector,
  liveLectureSelector,
  classTagSelector,
  LESSON_TYPES,
  LESSON_INPUT_OPTIONS,
  LessonInput,
  preReadSelector,
  setAssignment,
  setHomework,
  setLiveLecture,
  setClassTag,
  setPreRead,
  ClassTag,
} from 'features/classCreation';
import Field from 'components/Field';
import LessonChip from '../LessonChip';

export default function LessonInputGroup({ errors, allowedLessonTypes }) {
  const dispatch = useDispatch();
  const assignment = useSelector(assignmentSelector);
  const homework = useSelector(homeworkSelector);
  const preRead = useSelector(preReadSelector);
  const liveLecture = useSelector(liveLectureSelector);
  const classTag = useSelector(classTagSelector);

  const handleLiveLectureChange = useCallback(
    (newLiveLecture) => {
      dispatch(setLiveLecture(newLiveLecture));
    },
    [dispatch]
  );

  const handleClassTagChange = useCallback(
    (newClassTag) => {
      dispatch(setClassTag(newClassTag));
    },
    [dispatch]
  );

  const handleAssignmentChange = useCallback(
    (newAssignment) => {
      dispatch(setAssignment(newAssignment));
    },
    [dispatch]
  );

  const handleHomeworkChange = useCallback(
    (newHomework) => {
      dispatch(setHomework(newHomework));
    },
    [dispatch]
  );

  const handlePreReadChange = useCallback(
    (newPreRead) => {
      dispatch(setPreRead(newPreRead));
    },
    [dispatch]
  );

  return (
    <Field
      label="Lecture Requirements"
      className="m-b-l"
      name="lesson"
      serverErrors={errors}
    >
      <div className="m-b-s">
        {allowedLessonTypes.map((lessonType) => (
          <LessonChip
            lessonType={lessonType}
            title={LESSON_INPUT_OPTIONS[lessonType].label}
            key={lessonType}
          />
        ))}
      </div>
      {liveLecture && (
        <div className="row">
          <Field
            label="Live Lecture"
            labelClassName="hint normal"
            name={LESSON_TYPES.liveLecture}
            serverErrors={errors}
          >
            <LessonInput
              lessonType={LESSON_TYPES.liveLecture}
              value={liveLecture}
              onChange={handleLiveLectureChange}
            />
          </Field>
          <ClassTag
            handleClassTagChange={handleClassTagChange}
            classTag={classTag}
          />
        </div>
      )}
      {assignment && (
        <Field
          label="Assignment"
          labelClassName="hint normal"
          name={LESSON_TYPES.assignment}
          serverErrors={errors}
        >
          <LessonInput
            onChange={handleAssignmentChange}
            value={assignment}
            lessonType={LESSON_TYPES.assignment}
          />
          <div className="h6 disabled m-t-xxs">
            If no slug id is added, then a blank test will be created for you,
            to which you can add problems later.
          </div>
        </Field>
      )}
      {homework && (
        <Field
          label="Homework"
          labelClassName="hint normal"
          name="homework"
          serverErrors={errors}
        >
          <LessonInput
            onChange={handleHomeworkChange}
            value={homework}
            lessonType={LESSON_TYPES.homework}
          />
          <div className="h6 disabled m-t-xxs">
            If no slug id is added, then a blank test will be created for you,
            to which you can add problems later.
          </div>
        </Field>
      )}
      {preRead && (
        <Field
          label="Pre Read"
          labelClassName="hint normal"
          name={LESSON_TYPES.preRead}
          serverErrors={errors}
        >
          <LessonInput
            onChange={handlePreReadChange}
            value={preRead}
            lessonType={LESSON_TYPES.preRead}
          />
          <div className="h6 disabled m-t-xxs">
            If no slug id is added, then a blank test will be created for you,
            to which you can add problems later.
          </div>
        </Field>
      )}
    </Field>
  );
}
